export default class GoetelInputValidationError {
  constructor(key, result, message) {
    this.key = key;
    this.result = result;
    this.message = message != null ? message : 'ist fehlerhaft.';
  }
}
